import { useCallback, useEffect, useState } from 'react';

/**
 * Owns the diamond (vajra) layout toggle for one bhajan.
 *
 * Starts on, matching jnana-native's `useState(true)`. Native mounts a fresh screen
 * per bhajan; the web detail page is a single long-lived component reused across
 * navigations, so the choice has to be reset explicitly when the bhajan changes —
 * and only then. In particular a site-language switch must NOT reset it: the page
 * is not remounted, the markers survive transliteration, and the same bhajan in
 * Kannada is still the same diamond kriti, so discarding an explicit "View Normal
 * Lyrics" there would silently undo the user.
 */
export function useDiamondView(nodeId: string | undefined): {
  showingDiamondView: boolean;
  toggleDiamondView: () => void;
} {
  const [showingDiamondView, setShowingDiamondView] = useState(true);
  const toggleDiamondView = useCallback(() => setShowingDiamondView((v) => !v), []);

  useEffect(() => {
    setShowingDiamondView(true);
  }, [nodeId]);

  return { showingDiamondView, toggleDiamondView };
}
